import React from 'react';

// Swiper veya herhangi bir touch/gesture alanında "click" event'ine güvenmek
// WebView'da (Android/iOS) her zaman güvenilir değil: touch bittikten sonra
// tarayıcı ayrıca senkron olmayan bir "click" event'i de üretebiliyor ve bu,
// başka bir gesture'ın (Swiper, IonContent scroll vb.) durumu sıfırlamasıyla
// çakışıp ilk dokunuşu yutabiliyor. Bunun yerine touchstart/touchend'i kendimiz
// ölçüp, gerçek bir tıklama mı yoksa sürükleme mi olduğuna kendimiz karar veriyoruz.
// Mouse ile (masaüstü tarayıcı testi) kullanım için onClick fallback'i de tutuyoruz.
const TAP_MAX_DISTANCE = 10; // px
const TAP_MAX_DURATION = 500; // ms

export interface TapHandlers {
  onTouchStart: (e: React.TouchEvent) => void;
  onTouchEnd: (e: React.TouchEvent) => void;
  onClick: () => void;
}

export const createTapHandlers = (action: () => void): TapHandlers => {
  let start: { x: number; y: number; time: number } | null = null;
  let firedByTouch = false;

  return {
    onTouchStart: (e: React.TouchEvent) => {
      const t = e.touches[0];
      start = { x: t.clientX, y: t.clientY, time: Date.now() };
    },
    onTouchEnd: (e: React.TouchEvent) => {
      const s = start;
      start = null;
      if (!s) return;
      const t = e.changedTouches[0];
      const dx = Math.abs(t.clientX - s.x);
      const dy = Math.abs(t.clientY - s.y);
      const dt = Date.now() - s.time;
      if (dx < TAP_MAX_DISTANCE && dy < TAP_MAX_DISTANCE && dt < TAP_MAX_DURATION) {
        firedByTouch = true;
        action();
        // Tarayıcının touch'tan sonra ayrıca ürettiği "hayalet" click'i yok say
        setTimeout(() => {
          firedByTouch = false;
        }, 400);
      }
    },
    onClick: () => {
      if (firedByTouch) return; // zaten touchend ile tetiklendi
      action();
    },
  };
};
